// import { Routes } from './router.js'; // Removed incorrect import

(async () => {
    const { Core } = await importModule('Core');

    const CN_LOADING = '!loading'; // Reverted to original? Check theme setting
    const ATTR_VARIANT_ID = 'variant-id';
    const ATTR_BELONGS_FORM = 'form-child';
    
    customElements.define('product-to-cart', class extends Core {
        elements = {
            button: '[data-to-cart]'
        }
        
        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this._handleClick()
        }

        _handleClick() {
            this.addEventListener('click', this._onClick.bind(this))
        }

        _onClick(event) {
            if (!this.belongsToForm) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.loading = true;
            // If not part of a form, publish the add event. cart-provider will handle it.
            if (!this.belongsToForm) {
                this.addToCart(this.cartItem); // Reverted to original publish call
            }
            // If it belongs to a form, product-form.js handles the publish on submit.
        }
 
        addToCart(items) {
            // Determine source so cart-provider can choose the right post-add UX.
            const explicitSource = this.$button?.dataset.source;
            const isInOptionsList = this.closest('product-options-list');
            const isInExpressOptionList = this.closest('express-option-list');
            const isInProductCard = this.closest('#product-card, product-card');
            const isInCartRecommendation = this.closest('cart-notification-recommended-product, #cart-notification-recommended-product');
            const source = explicitSource
                || (isInExpressOptionList
                ? 'express-option-list'
                : isInOptionsList
                    ? 'options-list'
                    : isInCartRecommendation
                        ? 'cart-recommendation'
                        : isInProductCard
                            ? 'product-card'
                            : 'unknown');
            
            this.publish('cart:add', {
                items,
                source // Include determined source in the event detail
            });
        }

        _cartUpdateHandler(event) {
            // Reverted to original simpler handler
             setTimeout(() => {
                this.loading = false
            }, 1500)
        }

        get belongsToForm() {
            return this.hasAttribute(ATTR_BELONGS_FORM)
        }

        get cartItem() {
            let quantity = 1;
            // If not part of a standard form, try to find the closest quantity scope.
            if (!this.belongsToForm) {
                const qtyInput = this.closest('[data-quantity-scope]')?.querySelector('input[name="quantity"]')
                    || this.closest('td')?.querySelector('input[name="quantity"]');
                if (qtyInput) {
                    quantity = parseInt(qtyInput.value, 10) || 1;
                }
            }
            // If part of a form, product-form.js will handle the quantity via addToCart arguments
            // So defaulting to 1 here is fine for that case.
            return [{ 
                id: +this.getAttribute(ATTR_VARIANT_ID), 
                quantity: quantity
            }]
        }
        
        set loading(state) {
            this.$button?.classList.toggle(CN_LOADING, state);
        }

        get cartNotificationsEnabled() {
            return window.global?.cartNotificationsEnabled; // Safer access
        }

        set variantId(id) {
            this.setAttribute(ATTR_VARIANT_ID, id)
        }

    })
})();
